import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, router } from '@/client/router';
import { createQueryClient, indexedDbPersister } from '@/client/store';
import '@/client/index.css';

/**
 * Entry point.
 *
 * The query cache is restored from IndexedDB before the first render, so a
 * returning visitor sees their real schedule immediately and the network
 * refresh happens quietly behind it.
 */

const queryClient = createQueryClient();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: indexedDbPersister,
        maxAge: 1000 * 60 * 60 * 24 * 14,
        // Bump to invalidate every cached copy after a breaking data change.
        buster: 'v1',
      }}
      onSuccess={() => {
        // Replay anything that was queued while the tab was closed.
        void queryClient.resumePausedMutations();
      }}
    >
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  </StrictMode>,
);
